import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'theme/theme';
import { CheckIcon, MinusIcon } from '../Icon';

const CheckboxWrapper = styled.div`
  display: inline-block;
  position: relative;
`;


const Square = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  background: ${(props) => props.background};
  border: 1px solid ${theme.colors.mediumLight};
  svg {
    top: 0;
  }
  @media print {
    border: 1px solid #000;
    background: none;
  }
`;

const CheckboxBase = ({
  checked, indeterminate, disabled, onChange, onClick, name, background, style, ...other // eslint-disable-line
}) => (
  <CheckboxWrapper onClick={onClick} style={style} {...other}>
    <input
      type="checkbox"
      ref={(input) => {
        if (input) {
              input.checked = checked; // eslint-disable-line
              input.indeterminate = indeterminate; // eslint-disable-line
              input.disabled = disabled; // eslint-disable-line
        }
      }}
      onChange={onChange}
      name={name}
    />
    <Square
      className="checkbox"
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      background={background}
    >
      <CheckIcon className="check-icon" />
      <MinusIcon className="minus-icon" />
    </Square>
  </CheckboxWrapper>
);
CheckboxBase.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  background: PropTypes.string,
  backgroundChecked: PropTypes.string,
  backgroundDisabled: PropTypes.string,
  backgroundIndeterminate: PropTypes.string,
};
CheckboxBase.defaultProps = {
  checked: false,
  indeterminate: false,
  disabled: false,
  onChange: () => {},
  background: 'white',
  backgroundChecked: theme.colors.primary,
  backgroundDisabled: theme.colors.medium,
  backgroundIndeterminate: theme.colors.primary,
};


const Checkbox = styled(CheckboxBase)`
  color: #fff;
  outline-offset: -3px;
  
  input {
    position: absolute;
    left: 0;
    top: 0;
    min-width: 1em;
    width: 100%;
    height: 100%;
    z-index: 2;
    opacity: 0;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
  input:disabled {
    cursor: default;
  }
  
  .check-icon,
  .minus-icon {
    display: none;
  }
  
  input:checked + .checkbox .check-icon {
    display: block;
  }
  input:indeterminate + .checkbox .minus-icon {
    display: block;
  }
  
  input:checked + .checkbox {
    background: ${(props) => props.backgroundChecked};
    border-color: ${(props) => props.backgroundChecked};
    color: ${theme.colors.white};
  }
  input:indeterminate + .checkbox {
    background: ${(props) => props.backgroundIndeterminate};
    color: ${theme.colors.white};
  }
  input:disabled + .checkbox {
    background: ${(props) => props.backgroundDisabled};
    color: ${theme.colors.white};
  }
  input:disabled:checked + .checkbox {
    background: ${(props) => props.backgroundDisabledChecked};
    color: ${theme.colors.white};
  }
  
  ${(props) => props.hasError && css`
    outline: 3px solid ${theme.colors.primary};
  `}
  
  @media print {
    svg {
      fill: #000;
    }
  }
  
`;
Checkbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  background: PropTypes.string,
  backgroundChecked: PropTypes.string,
  backgroundDisabled: PropTypes.string,
  backgroundIndeterminate: PropTypes.string,
  backgroundDisabledChecked: PropTypes.string,
};
Checkbox.defaultProps = {
  checked: false,
  indeterminate: false,
  disabled: false,
  onChange: () => {},
  background: theme.colors.light,
  backgroundChecked: theme.colors.primary,
  backgroundDisabled: theme.colors.light,
  backgroundDisabledChecked: theme.colors.darker,
  backgroundIndeterminate: theme.colors.primary,
};

export default Checkbox;
